var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.074 5.927l-1.415-1.412-5.656 5.65L5.174 7.34 3.76 8.752l4.243 4.238zM16 2v14H2V2zM0 1v16a1 1 0 001 1h16a1 1 0 001-1V1a1 1 0 00-1-1H1a1 1 0 00-1 1z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/checkbox.svg";
export { SvgCheckbox as ReactComponent };